import classes from "./Copy.module.css";

function Copy() {
    return <div className={classes.copy}>
        &copy; {new Date().getFullYear()} SunShine
        </div>;
}

export default Copy;